<template>
  <transition name="fade" appear>
    <div class="overlay"></div>
  </transition>
</template>

<script>
export default {
  name: 'overlay',
}</script>

<style scoped lang="scss">
.overlay{
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.25);
  z-index: 90002;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 500ms;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/Overlay.vue